import { render, staticRenderFns } from "./extratoLicencaPremioServidor.vue?vue&type=template&id=0d33d75d&scoped=true&"
import script from "./extratoLicencaPremioServidor.vue?vue&type=script&lang=js&"
export * from "./extratoLicencaPremioServidor.vue?vue&type=script&lang=js&"
import style0 from "./extratoLicencaPremioServidor.vue?vue&type=style&index=0&id=0d33d75d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d33d75d",
  null
  
)

export default component.exports